import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { Apple, PlayCircle, ExternalLink } from "lucide-react";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useLang } from "../context/LangContext";

const APP_STORE_URL = "#";
const GOOGLE_PLAY_URL = "#";
const OFFICIAL_URL = "https://holylandaward.iarc.org/";

export const Navbar = () => {
  const { t } = useLang();
  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#13131A]/85 backdrop-blur-xl border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Logo size="md" />

        <nav className="hidden lg:flex items-center gap-7 text-sm font-medium">
          <a
            href="#features"
            data-testid="nav-features-link"
            className="text-white/65 hover:text-white transition-colors"
          >
            {t("nav.features")}
          </a>
          <a
            href={OFFICIAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-official-link"
            className="text-white/65 hover:text-white transition-colors inline-flex items-center gap-1"
          >
            {t("nav.official")}
            <ExternalLink className="h-3 w-3" />
          </a>
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={APP_STORE_URL}
            data-testid="nav-appstore-btn"
            className="hidden sm:flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full px-4 h-10 text-xs font-semibold transition-colors"
          >
            <Apple className="h-4 w-4" />
            App Store
          </a>
          <a
            href={GOOGLE_PLAY_URL}
            data-testid="nav-googleplay-btn"
            className="hidden md:flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full px-4 h-10 text-xs font-semibold transition-colors"
          >
            <PlayCircle className="h-4 w-4 text-[#34C759]" />
            Google Play
          </a>
          <LanguageSwitcher />
          <a href="#download" data-testid="nav-download-cta">
            <Button className="bg-[#007AFF] hover:bg-[#0A84FF] text-white rounded-full px-5 h-10 text-sm font-semibold">
              {t("nav.download")}
            </Button>
          </a>
        </div>
      </div>
    </header>
  );
};
